import { render, staticRenderFns } from "./ExpenseContainer.vue?vue&type=template&id=b2a96e62&scoped=true&"
import script from "./ExpenseContainer.vue?vue&type=script&lang=js&"
export * from "./ExpenseContainer.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExpenseContainer.vue?vue&type=style&index=1&id=b2a96e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a96e62",
  null
  
)

export default component.exports